import apiService from "~/services/service";
import API_ROUTES_V2 from "~/api-routes-v2";

export type ResourceType =
  | "audittrail"
  | "comment"
  | "dashboards"
  | "director"
  | "documents"
  | "employee"
  | "entity"
  | "events"
  | "officer"
  | "payslip"
  | "process"
  | "request"
  | "shareholder"
  | "task"
  | "usermanagement";

export type Action =
  | "view"
  | "list"
  | "create"
  | "modify"
  | "delete"
  | "execute"
  | "upload"
  | "approve"
  | "release"
  | "change_overdue_status"
  | "mark_not_needed"
  | "view_internal"
  | "create_internal"
  | "update_status"
  | "reassign"
  | "view_any"
  | "view_self"
  | "modify_any"
  | "modify_self";

export interface CheckPermissionParams {
  resource: ResourceType;
  action: Action;
  resourceId?: string;
  resourceAttr?: Record<string, unknown>;
}

export interface CheckPermissionResponse {
  success: boolean;
  data: { allowed: boolean };
}

export async function checkPermission(
  params: CheckPermissionParams,
): Promise<boolean> {
  try {
    const response = await apiService<CheckPermissionResponse>(
      API_ROUTES_V2.CHECK_PERMISSION,
      "POST",
      {
        body: params,
        suppressToast: true,
      },
    );
    return response?.data?.allowed ?? false;
  } catch {
    return false;
  }
}
